export const PROCUREMENT_TYPES = {
  NEW: "NEW",
  EXPANSION: "EXPANSION",
  REFRESH: "REFRESH",
  NONE: "NONE",
};
export const SK_SEPERATOR = "|";

export const SK_PROC_STAGE_PREFIX = `PHASE${SK_SEPERATOR}Assmt${SK_SEPERATOR}STAGE${SK_SEPERATOR}`;

/**
 * Builds the DynamoDB Sort Key (SK) for a procurement stage.
 * @param {string} stageName - The stage name (e.g. "Sizing", "Network", "CommVault", "BOM", "Site")
 * @returns {string} The SK value (e.g. "STAGE|Sizing")
 */
export const buildStageSK = (stageName) => SK_PROC_STAGE_PREFIX + stageName;

export const PROCUREMENT_STATUS = {
  Initial: "Initial",
  Submitted: "Submitted",
  Approved: "Approved",
};

export const ENTITY_TYPES = {
  Procurement: "Procurement",
  ProcurementStage: "ProcurementStage",
};

export const PROCUREMENT_STAGES = {
  Sizing: "Sizing",
  Network: "Network",
  CommVault: "CommVault",
  BOM: "BOM",
  Site: "Site",

  CommVault_Network:"CommVault_Network",

};

export const PROCUREMENT_STAGES_KEY = {
  Sizing: buildStageSK(PROCUREMENT_STAGES.Sizing),
  Network: buildStageSK(PROCUREMENT_STAGES.Network),
  CommVault: buildStageSK(PROCUREMENT_STAGES.CommVault),
  BOM: buildStageSK(PROCUREMENT_STAGES.BOM),
};

export const PROCUREMENT_STAGES_MAP = {
  DEMAND_MANAGEMENT: {
    DEMAND_INTAKE: "DEMAND_INTAKE",
    SIZING: "SIZING",
    "BILL OF MATERIALS": "BILL OF MATERIALS",
    QUOTE: "QUOTE",
  },
};

export const PROCUREMENT_STAGES_STATUS_COLOR = {
  Initial: "transparent",
  Submitted: "transparent",
  Approved: "transparent",
};

// Enterprise-grade subtle status indicator colors (for dots/badges only)
export const PROCUREMENT_STATUS_INDICATOR = {
  Initial: { dot: "#F59E0B", bg: "#FFFBEB", text: "#B45309" },      // Amber - In Progress
  Submitted: { dot: "#3B82F6", bg: "#EFF6FF", text: "#1D4ED8" },    // Blue - Ready for Review
  Approved: { dot: "#10B981", bg: "#ECFDF5", text: "#059669" },     // Green - Completed
};

export const TOOLTIP_LABELS={
  "created_at":"Created at",
  "created_by":"Created by",
  "completed_at":"Reviewed at",
  "completed_by":"Reviewed by",
  "assessed_at":"Assessment completed at",
  "assessed_by":"Assessment completed by",
}